import { render, staticRenderFns } from "./errorTips.vue?vue&type=template&id=7c0d6412&scoped=true&"
import script from "./errorTips.vue?vue&type=script&lang=js&"
export * from "./errorTips.vue?vue&type=script&lang=js&"
import style0 from "./errorTips.vue?vue&type=style&index=0&id=7c0d6412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d6412",
  null
  
)

export default component.exports